module.exports = __webpack_public_path__ + "static/media/116.5b5ceffb.png";